import { Component, EventEmitter, OnInit, Output, Renderer2, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';

import { LoaderService } from '@teem/app/core/services/loader.service';
import { AuthService } from '@teem/app/core/services/auth.service';
import { CountryService } from '@teem/app/core/services/country.service';
import { country as CountryApi } from "@teem/constants/api";
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
import { ProfileService } from '@teem/app/core/services/profile.service';
import { CustomerAuthService } from '@teem/app/core/services/customer-auth.service';
declare var $;

@Component({
	selector: 'app-signin',
	templateUrl: './signin.component.html',
	styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
	@Output() authState = new EventEmitter<string>();
	signinForm: FormGroup;
	otpForm: FormGroup;
	step: number = 1;
	resendTimer: number = 0;
	resendDisabled: boolean = true;
	interval: any;
	countries: any;
	langAttribute: any = 'en';
	guest_route: any;
	showPassword = false;

	countryListApi: string = CountryApi.signup;
	selectedCountry: any = { id: 682, calling_code: '966', name: 'Saudi Arabia' };
	currentTab: 'email' | 'phone' = 'email';
	countryList = [
		{ id: 1, name: 'United States', calling_code: '+1', iso2: 'us' },
		{ id: 2, name: 'United Kingdom', calling_code: '+44', iso2: 'gb' },
		{ id: 3, name: 'India', calling_code: '+91', iso2: 'in' },
		{ id: 4, name: 'Canada', calling_code: '+1', iso2: 'ca' }
	];

	separateDialCode = true;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
	PhoneNumberFormat = PhoneNumberFormat;
	preferredCountries: CountryISO[] = [CountryISO.SaudiArabia, CountryISO.UnitedArabEmirates, CountryISO.Kuwait, CountryISO.Bahrain, CountryISO.UnitedStates, CountryISO.UnitedKingdom];

	private clickListener: () => void;

	constructor(
		private fb: FormBuilder,
		private renderer: Renderer2,
		private loaderService: LoaderService,
		private authService: AuthService,
		private countryService: CountryService,
		private router: Router,
		private profileService: ProfileService,
		private customerAuthService: CustomerAuthService
	) {
		this.signinForm = this.fb.group({
			email: ['', [Validators.required, Validators.email]],
			password: ['', [Validators.required, Validators.minLength(6)]],
			phone: ['', [Validators.required]],
			country_id: [682, [Validators.required]],
		});

		this.otpForm = this.fb.group({
			0: ['', [Validators.required, Validators.pattern(/^\d$/)]],
			1: ['', [Validators.required, Validators.pattern(/^\d$/)]],
			2: ['', [Validators.required, Validators.pattern(/^\d$/)]],
			3: ['', [Validators.required, Validators.pattern(/^\d$/)]],
		});
	}

	ngOnInit(): void {
		this.isLangArabic();
		this.loadCountries();
		setTimeout(() => {
			$('select[nice-select]').niceSelect('update');
		}, 300);
	}

	ngAfterViewInit(): void {
		this.updateLeftStepHeight();

		const signupStepsRight = document.querySelector('.signup_steps_right') as HTMLElement;

		if (signupStepsRight) {
			this.clickListener = this.renderer.listen(signupStepsRight, 'click', () => {
				this.updateLeftStepHeight();
			});
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['step']) {
			this.updateLeftStepHeight();
		}
	}

	private updateLeftStepHeight(): void {
		const signupStepsRight = document.querySelector('.signup_steps_right') as HTMLElement;
		const signupStepsLeft = document.querySelectorAll('.signup_steps_left');

		if (signupStepsRight) {
			const rightHeight = signupStepsRight.clientHeight;
			signupStepsLeft.forEach((leftStep) => {
				this.renderer.setStyle(leftStep, 'height', `${rightHeight + 60}px`);
			});
		}
	}

	async loadCountries() {
		await this.countryService.signup().subscribe((data: any) => {
			this.countries = data;
		});
	}

	getCountryByFind(id) {
		return this.countries.find(x => x.id == id);
	}

	onChangeCountry(id) {
		this.selectedCountry = this.getCountryByFind(id);
	}

	switchTab(tab: 'email' | 'phone'): void {
		console.log(tab);
		this.currentTab = tab;
		if (tab === 'email') {
			this.signinForm.get('phone')?.reset();
		} else {
			this.signinForm.get('email')?.reset();
			this.signinForm.get('password')?.reset();
		}
	}

	isFormValid(): boolean {
		return this.signinForm.get('email')?.valid && this.signinForm.get('password')?.valid;
	}

	isFormPhoneValid(): boolean {
		return this.signinForm.get('phone')?.valid;
	}



	//  nextStep(): void {
	//     this.step++
	//   }

	nextStep(): void {
		if (this.step == 1) {
			this.step++;
			// let fd = this.signupForm.value;
			let fd;
			if (this.currentTab == 'email') {
				fd = {
					email: this.signinForm.get('email')?.value,
					password: this.signinForm.get('password')?.value
				};
			} else {
				fd = {
					phone: this.signinForm.get('phone')?.value,
					country_id: this.signinForm.get('country_id')?.value,
				};
			}

			console.log(fd)
			this.loaderService.startLoading();
			this.profileService.sendOtp(fd).subscribe((res: any) => {
				this.loaderService.stopLoading();
				// if (this.step === 2) {
				//   this.resendTimer = 0;
				// }
			}, err => {
				this.loaderService.stopLoading();
				Swal.fire(i18n.alert.error, i18n.getError(err), "error");
			});
		} else if (this.step === 2) {
			this.resendTimer = 0;
			const otp = Object.values(this.otpForm.value).join('');
			let fd;
			if (this.currentTab == 'email') {
				fd = { email: this.signinForm.get('email')?.value };
			} else {
				fd = { phone: this.signinForm.get('phone')?.value };
			}

			fd.otp = otp;
			this.loaderService.startLoading();
			// setTimeout(() => {
			//   this.step++;
			//   this.loaderService.stopLoading();
			// }, 1000)
			this.authService.verifyLogin(fd).subscribe((res: any) => {
				this.loaderService.stopLoading();
				this.step++;
			}, err => {
				this.loaderService.stopLoading();
				Swal.fire(i18n.alert.error, i18n.getError(err), "error");
			});
		}
	}

	isLangArabic(): void {
		this.langAttribute = document.documentElement.getAttribute('lang');
		console.log(this.langAttribute);
	}

	previousStep(): void {
		if (this.step > 1) {
			this.step--;
			this.updateLeftStepHeight()
		}
	}

	get otpControls(): FormControl[] {
		return Object.keys(this.otpForm.controls).map(
			key => this.otpForm.get(key) as FormControl
		);
	}

	get phoneNumber() {
		const phoneData = this.signinForm.get('phone')?.value;
		return phoneData?.internationalNumber;
	}

	focusNext(event: Event, index: number): void {
		const input = event.target as HTMLInputElement;
		if (input.value && index < this.otpControls.length - 1) {
			const nextInput = document.querySelectorAll<HTMLInputElement>('.otp-input')[index + 1];
			nextInput?.focus();
		}
	}

	startResendTimer(): void {
		this.resendDisabled = true;
		this.resendTimer = 30;
		if (this.interval) {
			clearInterval(this.interval);
		}
		this.interval = setInterval(() => {
			if (this.resendTimer > 0) {
				this.resendTimer--;
			} else {
				this.resendDisabled = false;
				clearInterval(this.interval);
			}
		}, 1000);
	}

	resendOTP(): void {
		this.startResendTimer();
		const phoneData = this.signinForm.get('phone')?.value;
		let fd;
		if (this.currentTab == 'email') {
			fd = { username: this.signinForm.get('email')?.value };
		} else {
			fd = {
				username: this.cleanPhoneNumber(phoneData?.number),
				countrycode: phoneData?.countryCode,
				dialcode: phoneData?.dialCode
			};
		}

		this.loaderService.startLoading();
		this.profileService.resendOtp(fd).subscribe((res: any) => {
			this.loaderService.stopLoading();
		}, err => {
			this.loaderService.stopLoading();
			Swal.fire(i18n.alert.error, i18n.getError(err), "error");
		});
	}

	cleanPhoneNumber(phone: string): string {
		return phone.replace(/\s+/g, '').replace(/^0+/, '');
	}

	onSubmit(): void {
		if (this.isFormValid()) {
			const token = localStorage.getItem('fcm_token');
			const loginData = this.currentTab === 'email'
				? { username: this.signinForm.get('email')?.value, password: this.signinForm.get('password')?.value, fcm_web_token: token }
				: { username: this.signinForm.get('phone')?.value, fcm_web_token: token };

			this.loaderService.startLoading();

			this.profileService.signin(loginData).subscribe({
				next: (res: any) => {
					this.loaderService.stopLoading();
					Swal.fire(i18n.alert.success, i18n.customer.signin.success, 'success');
					// this.router.navigate(['/dashboard']);
					if (this.currentTab === 'email') {
						this.customerAuthService.login();
						if (res.intended_url?.includes("checkout")) {
							window.location.href = res.intended_url;
						} else {
							window.location.reload();
						}
					} else {
						this.step++;
					}
				},
				error: (err) => {
					this.loaderService.stopLoading();
					// Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
					// Set server side error
					if (err.status === 422) {
						if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
							let validationErrors = err.error.errors;

							Object.keys(validationErrors).forEach((prop) => {
								this.signinForm.get(prop)?.setErrors({
									serverError: validationErrors[prop]
								})
							})
						}
					} else if (err.status === 403 && err.error) {
						this.signinForm.get(this.currentTab)?.setErrors({ serverError: err.error.error })
					}
				},
			});
		}
	}

	loginViaPhone(): void {
		if (this.isFormPhoneValid()) {
			const token = localStorage.getItem('fcm_token');
			const phoneData = this.signinForm.get('phone')?.value;
			const loginData = {
				username: phoneData?.number,
				countrycode: phoneData?.countryCode,
				dialcode: phoneData?.dialCode,
				fcm_web_token: token
			};

			this.loaderService.startLoading();

			this.profileService.signin(loginData).subscribe({
				next: (res) => {
					this.loaderService.stopLoading();
					// Swal.fire(i18n.alert.success, 'Login successful!', 'success');
					// this.router.navigate(['/dashboard']);
					this.step++;
				},
				error: (err) => {
					this.loaderService.stopLoading();
					// Set server side error
					if (err.status === 422) {
						if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
							let validationErrors = err.error.errors;

							Object.keys(validationErrors).forEach((prop) => {
								this.signinForm.get(prop)?.setErrors({
									serverError: validationErrors[prop]
								})
							})
						}
					} else if (err.status === 403 && err.error) {
						this.signinForm.get(this.currentTab)?.setErrors({ serverError: err.error.error })
					}
				},
			});
		}
	}

	verifyLoginViaPhone(): void {
		this.resendTimer = 0;
		const otp = Object.values(this.otpForm.value).join('');
		const phoneData = this.signinForm.get('phone')?.value;
		let fd;

		fd = {
			username: phoneData?.number,
			countrycode: phoneData?.countryCode,
			dialcode: phoneData?.dialCode
		};

		fd.otp = otp;
		this.loaderService.startLoading();
		this.profileService.verifyLogin(fd).subscribe((res: any) => {
			this.loaderService.stopLoading();
			this.customerAuthService.login();
			Swal.fire(i18n.alert.success, i18n.customer.signin.success, 'success');
			if (res.intended_url?.includes("checkout")) {
				window.location.href = res.intended_url;
			} else {
				window.location.reload();
			}
		}, err => {
			this.loaderService.stopLoading();
			Swal.fire(i18n.alert.error, i18n.getError(err), "error");
		});
	}

	authToggle(state: string) {
		this.authState.emit(state);
	}

	continueAsGuest() {
		this.guest_route = (window as any).guestRoute ? (window as any).guestRoute : null;
		window.location.href = this.guest_route;
	}

	
	togglePasswordVisibility(): void {
		this.showPassword = !this.showPassword;
	}
}
